import styled from 'styled-components'
import COLORS from '@colors'

export const IconWrapper = styled.div`
  position: absolute;
  padding: 0 8px;
  ${({ alignRight }) =>
    alignRight &&
    `
      right: 16px; 
      height: 24px; 
      width: 24px; 
      cursor: pointer; 
      padding: 10px 0;
    `}
`

export const PinWrapper = styled.div`
  padding: 0 8px;
`

export const HeaderActionsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 30%;
`

export const HeaderActionIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  box-sizing: content-box;
  cursor: pointer;
  padding-top: 8px;
  text-align: center;
`

export const BodyText = styled.div`
  width: 100%;
  p {
    :not(.tooltiptext) {
      color: ${COLORS.whiteA1};
      font: 500 14px/17px Barlow;
      b {
        color: ${COLORS.gray45};
      }
    }
  }
`

export const ItemGroup = styled.div`
  padding: 20px 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const Body = styled.div`
  width: 100%;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  height: fit-content;
  align-items: center;
`
export const Item = styled.div`
  align-items: flex-start;
  position: relative;
  border: 1px solid ${COLORS.whiteD};
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  transition: 0.3s ease;
  padding: 20px;
  padding-bottom: 0;
  ${({ active }) => !active && `height:80px;`};
`
export const BodyItem = styled.div`
  position: relative;
  min-width: 81px;
  max-width: 140px;
  :last-child {
    padding-right: 0;
  }
  p {
    ${({ hideTextOverflow }) =>
      hideTextOverflow &&
      `
      :not(.tooltiptext) {
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
        overflow: hidden
      }
  `}
  }
`

export const ErrorItem = styled.div`
  border-radius: 4px;
  width: 100%;
  padding: 10px;
  ${({ internalError }) =>
    internalError
      ? `
    border: 1px solid ${COLORS.opaqueRustyRed};
    color: ${COLORS.rustyRed};
    background-color: ${COLORS.transparentRustyRed};
  `
      : `
    border: 1px solid ${COLORS.opaqueLeatherWarning};
    color: ${COLORS.leather};
    background-color: ${COLORS.transparentLeatherWarning};
  `};
`

export const FooterSeparator = styled.hr`
  left: -4px;
  position: relative;
  width: calc(100% + 49px);
  border: 0;
  border-top: 1px solid ${COLORS.whiteD};
`
export const Footer = styled.div`
  height: 64.5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0px;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 34px;
  width: 100%;
`

export const Pill = styled.div`
  border: 0;
  border-radius: 4px;
  height: 32px;
  width: 100px;
  color: ${({ status }) => {
    switch (status) {
      case 1:
        return COLORS.leather
      default:
        return COLORS.white
    }
  }};
  text-align: center;
  font: 500 14px/17px Barlow;
  background-color: ${({ status, isInternalError }) => {
    switch (status) {
      case 0:
        return COLORS.whiteA1
      case 2:
        return COLORS.lightGreen
      case 3:
        if (isInternalError) {
          return COLORS.rustyRed
        } else {
          return COLORS.leather
        }
      default:
        return COLORS.transparentLeather
    }
  }};
  outline: 0;
  padding: 7px;
`

export const ViewRealty = styled.div`
  height: 24px;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: ${({ disabled }) => disabled && '0.5'};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  p {
    margin-right: 5px;
  }
`

export const UserWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  position: relative;
  font: 500 14px/28px Barlow;
  letter-spacing: 0;
  color: ${COLORS.gray45};
`

export const UserIcon = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${COLORS.whiteA1};
  border: 1px solid ${COLORS.whiteA1};
  color: white;
  position: relative;
  border-radius: 50%;
  line-height: 22px;
  text-align: center;
  margin-right: 10px;
`
